import React, { useEffect, useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TextField from '@mui/material/TextField';
import FilterListIcon from '@mui/icons-material/FilterList';
import { connect } from 'react-redux';
import Grid from '@mui/material/Grid';
import { API } from 'Amplify';

import UserList from './UserList';
import FleetList from './FleetList';
import { FleetsActionsClaim } from './fleets-actions-claim.part';
import { FleetsActionsImages } from './fleets-actions-images.part';
import { FleetsActionsCloudflex } from './fleets-actions-cloudflex.part';

import './fleets.scss';
import useUser, { isUserEligibleToCfuDevices } from '../../utils/useUser';

function Fleets(props) {
  const { admin: { admin = false } = {} } = props;
  const [tab, setTab] = useState(0);
  const [req, setReq] = useState(0);
  const [users, setUsers] = useState(null);
  const [fleets, setFleets] = useState(null);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [loadingFleets, setLoadingFleets] = useState(false);
  const [filter, setFilter] = useState(false);
  const [displayList, setDisplayList] = useState(null);
  const [error, setError] = useState(false);
  const [user, _loadingUser] = useUser();

  let Component, componentProps, errorMsg, filterDisable, content;
  const isUserAllowedToCreateCfuDevices = admin || isUserEligibleToCfuDevices(user);

  const refresh = () => setReq(req + 1);

  const findObj = (tab, search) => {
    setDisplayList([]);
    setFilter(search);
    setTab(tab);
    setError(undefined);
  };

  const Components = {
    Fleets: {
      Component: FleetList,
      props: { admin, fleets: displayList, users, refresh, loading: loadingFleets, setError, setFleets, findObj },
      content: fleets,
      set: setFleets,
      loading: loadingFleets,
      filter: (initial, filterStr) => {
        if (!filterStr) {
          return initial;
        }
        const firstPass = initial.filter((fleet) => fleet.thingGroupName.toLowerCase().includes(filterStr.toLowerCase()));

        // biome-ignore lint/performance/noAccumulatingSpread: Keep the spread operator for clarity
        const parents = Array.from(new Set(firstPass.reduce((acc, fleet) => [...acc, ...(fleet.parentGroupNames || [])], [])));

        const secondPass = initial.filter((fleet) => parents.includes(fleet.thingGroupName));

        return [...firstPass, ...secondPass];
      },
    },
    Users: {
      Component: UserList,
      props: { admin, users: displayList, fleets, refresh, loading: loadingUsers, setError, findObj },
      content: users,
      set: setUsers,
      loading: loadingUsers,
      filter: (initial, filterStr) => {
        if (!filterStr) {
          return initial;
        }
        return initial.filter((user) => (filterStr ? user.userId.includes(filterStr) || user.email.includes(filterStr) : true));
      },
    },
  };

  useEffect(() => {
    setLoadingFleets(true);
    setLoadingUsers(true);
    console.log('NOT HERE?!');
    API.get('IO_API', `/user/all`, { headers: { 'Content-Type': 'application/json' } })
      .then((res) => {
        setLoadingUsers(false);
        setUsers(res);
      })
      .catch((err) => {
        setLoadingUsers(false);
        setError(err.response);
      });
    API.get('IO_API', `/fleet/all`, { headers: { 'Content-Type': 'application/json' } })
      .then((res) => {
        setLoadingFleets(false);
        const fleetsLocalAction = JSON.parse(window.localStorage.getItem('fleets')) || [];
        const newLocal = [];
        const reqFleets = res || [];

        fleetsLocalAction.forEach((fleet) => {
          const { action, thingGroupName } = fleet;

          const index = reqFleets.findIndex((remoteFleet) => remoteFleet.thingGroupName === thingGroupName);

          if (index < 0) {
            if (action === 'post') {
              newLocal.push(fleet);
              reqFleets.push(fleet);
            }
          } else if (action === 'del') {
            newLocal.push(fleet);
            reqFleets[index].action = action;
          }
        });

        window.localStorage.setItem('fleets', JSON.stringify(newLocal));

        setFleets(reqFleets);
      })
      .catch((err) => {
        setLoadingFleets(false);
        setError(err.response);
      });
  }, [req]);

  useEffect(() => {
    const tabObj = Object.entries(Components)[tab][1];
    const { content = [], filter: filterFun = () => content } = tabObj || {};

    setDisplayList(filterFun(content, filter));
  }, [users, fleets, filter, tab]);

  const onChange = (_ev, newValue) => {
    setDisplayList([]);
    setFilter('');
    setTab(newValue);
    setError(undefined);
  };

  const tabs = Object.entries(Components).map(([key, val], idx) => {
    if (tab === idx) {
      ({ Component = null, props: componentProps = {}, loading: filterDisable } = val || {});
    }

    return (
      <Tab
        label={key}
        key={key}
        id={idx}
      />
    );
  });

  if (error) {
    errorMsg = `${error.data.body || error.data}`;
  }

  if (Component) {
    const filterProps = {};
    content = (
      <div>
        <Grid
          container
          spacing={0}
        >
          <Grid item>
            <FilterListIcon />
          </Grid>
          <Grid item>
            <TextField
              value={filter || ''}
              onChange={(ev) => setFilter(ev.target.value)}
              disabled={filterDisable}
              {...filterProps}
            />
          </Grid>
        </Grid>
        <Component {...componentProps} />
      </div>
    );
  }

  return (
    <React.Fragment>
      <div
        style={{
          height: '90%',
          overflowY: 'auto',
          display: 'grid',
          gridTemplateColumns: '1fr',
          gridTemplateRows: 'minmax(20px, 100px) minmax(300px, 1fr) minmax(20px, 100px)',
        }}
      >
        <Tabs
          style={{ margin: 'auto' }}
          value={tab}
          onChange={onChange}
        >
          {tabs}
        </Tabs>

        {content}

        {errorMsg ? <div>{errorMsg}</div> : null}
      </div>

      <div
        style={{ padding: '16px 4px' }}
        className="fleet-actions"
      >
        <div style={{ display: 'flex', justifyContent: 'end', gap: '8px' }}>
          <FleetsActionsClaim fleets={fleets} />

          <FleetsActionsImages admin={admin} />

          {isUserAllowedToCreateCfuDevices && <FleetsActionsCloudflex fleets={fleets} />}
        </div>
      </div>
    </React.Fragment>
  );
}

const mapStateToProp = (state) => {
  const { admin } = state;
  return { admin };
};

export default connect(mapStateToProp, null)(Fleets);
